import $ from 'jquery';
import Region from 'blocks/region/region';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaBlocked',
			dom: {
				layout: '#layout',
				region: '.js-blocked-region'
			},
			classes: {
				state: {
					active: 'b-blocked_state_active'
				},
				layout: {
					state: {
						blocked: 'b-layout_state_blocked'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.products = {};
		this.productType = false;
		return this;
	}

	getDom() {
		this.$layout = $(this.options.dom.layout);
		this.$region = this.$el.find(this.options.dom.region);
		return this;
	}

	blocked() {
		this.$layout.addClass(this.options.classes.layout.state.blocked);
	}

	render() {
		if (this.$el.length) {
			this.products = yotaPortlets.region.products;
			this.getDom();
			this.region = new Region({el: this.$region}).render();

			if (yotaPortlets.productType) {
				this.productType = yotaPortlets.productType;

				if (this.products[yotaPortlets.productType] === true) {
					window.location.href = '/';
				}
				if (this.products[yotaPortlets.productType] === false) {
					this.blocked();
				}
			}
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/blocked/blocked.js